import { EntityAdapter, createEntityAdapter, Update } from 'src/app/common/state/entity';
import { Action, createReducer, on } from 'src/app/common/state/store';
import {
  IBudgetDetail,
  IBudgetDetailEntityState,
} from '../../../common/interface';
import {
  AddBudgetDetailAction,
  AddBudgetDetailSuccessAction,
  DeleteBudgetDetailAction,
  DeleteBudgetDetailSuccessAction,
  GetBudgetDetailAction,
  GetBudgetDetailSuccessAction,
  ResetBudgetDetailStore,
  UpdateBudgetDetailAction,
  UpdateBudgetDetailSuccessAction,
} from '../../actions/budget-detail.action';

export const BudgetDetailAdaptor: EntityAdapter<IBudgetDetail> =
  createEntityAdapter<IBudgetDetail>();
const initialBudgetState: IBudgetDetailEntityState =
  BudgetDetailAdaptor.getInitialState();

const budgetDetailReducer = createReducer(
  initialBudgetState,
  on(GetBudgetDetailAction, (state) => ({ ...state })),
  on(GetBudgetDetailSuccessAction, (state, { budgetDetails }) => {
    if (budgetDetails == null) return state;
    if (budgetDetails.length == 0) return state;

    const rows: IBudgetDetail[] = [];
    budgetDetails.forEach((item) => {
      if (item) {
        rows.push(item);
      }
    });

    if (rows.length == 0) return state;

    if (state?.ids?.length === 0) {
      return BudgetDetailAdaptor.addMany(rows, state);
    }
    return BudgetDetailAdaptor.upsertMany(rows, state);
  }),
  on(AddBudgetDetailAction, (state) => ({ ...state })),
  on(AddBudgetDetailSuccessAction, (state, { budgetDetail }) => {
    if (budgetDetail) {
      return BudgetDetailAdaptor.addOne(budgetDetail, state);
    }
    return state;
  }),
  on(UpdateBudgetDetailAction, (state) => ({ ...state })),
  on(UpdateBudgetDetailSuccessAction, (state, { budgetDetail }) => {
    if (budgetDetail) {
      const updateBudget: Update<IBudgetDetail> = {
        id: budgetDetail.id!,
        changes: budgetDetail,
      };
      return BudgetDetailAdaptor.updateOne(updateBudget, state);
    }
    return state;
  }),
  on(DeleteBudgetDetailAction, (state) => ({ ...state })),
  on(DeleteBudgetDetailSuccessAction, (state, { budgetDetail }) => {
    if (budgetDetail) {
      const deleteBudget: Update<IBudgetDetail> = {
        id: budgetDetail.id!,
        changes: budgetDetail,
      };
      return BudgetDetailAdaptor.updateOne(deleteBudget, state);
    }
    return state;
  }),
  on(ResetBudgetDetailStore, (state) => BudgetDetailAdaptor.removeAll(state)),
);

export function BudgetDetailReducer(
  state: IBudgetDetailEntityState | undefined,
  action: Action,
): IBudgetDetailEntityState {
  return budgetDetailReducer(state, action);
}
